/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Saturation_LabelInputs */



/**
* | output |
* | --- |
* | "Saturation" |
*
* @param {Video_Filters_Saturation_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_saturation_label = /** @type {((inputs?: Video_Filters_Saturation_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Saturation_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saturation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sättigung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Saturazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Насыщенность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Saturación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("饱和")
	if (locale === "ja") return /** @type {LocalizedString} */ ("飽和")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिपूर्णता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saturação")
	return /** @type {LocalizedString} */ ("Saturation")
});